import React from "react";
import { Container, Typography, Divider } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function MapGuide() {
    const { t } = useTranslation();
    return (
        <Container maxWidth="md" sx={{ mt: '50px', py: 4 }}>
            <Typography variant="h3" gutterBottom>
                {t('Footer.MapGuide')}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                {t('Guides.MapGoal')}
            </Typography>

            <Typography paragraph>
                {t('Guides.MapDetailsLater')}
            </Typography>

            <Typography paragraph>
                {t('Guides.ContentLater')}
            </Typography>
        </Container>
    );
}
